// HTTP for social posts (docs/SOCIAL_BACKEND.md §1). Only data/store.js
// calls this. The API answers errors with HTTP 200 and statusCode 0; every
// call here throws on those, with the server's words and reason.
import axios from 'axios'
import API from '../../../../../config/API'

const headers = () => ({
  'Content-Type': 'application/json',
  authorization: 'Basic YmV1YXBwOmJldWFwcA==',
  accessToken: `${localStorage.getItem('accessToken')}`,
})

const unwrap = (res) => {
  const d = res && res.data
  if (d && d.statusCode === 1) {
    const r = d.responseData
    return (r && r.result !== undefined ? r.result : r) || {}
  }
  const e = new Error((d && d.error && (d.error.responseMessage || d.error.message)) || 'Request failed')
  e.code = d && d.error && d.error.errorCode
  e.reason = d && d.error && d.error.reason
  throw e
}

export const listPosts = (params = {}) => axios.get(API.SOCIAL_POSTS, { headers: headers(), params }).then(unwrap)
export const createPost = (post) => axios.post(API.SOCIAL_POSTS, post, { headers: headers() }).then(unwrap).then(r => r.post)
export const updatePost = (id, post) => axios.put(`${API.SOCIAL_POSTS}/${id}`, post, { headers: headers() }).then(unwrap).then(r => r.post)
export const removePost = (id) => axios.delete(`${API.SOCIAL_POSTS}/${id}`, { headers: headers() }).then(unwrap)
export const restorePostApi = (id) => axios.post(`${API.SOCIAL_POSTS}/${id}/restore`, {}, { headers: headers() }).then(unwrap).then(r => r.post)

// A data URL (a thumbnail drawn in the browser, or a photo from an old post)
// goes to S3 through the designer's upload, and the post keeps the address.
const dataUrlToFile = (dataUrl, name) => {
  const [head, body] = String(dataUrl).split(',')
  const mime = (head.match(/data:([^;]+)/) || [])[1] || 'image/jpeg'
  const bin = atob(body || '')
  const bytes = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
  return new File([bytes], name || `post-${Date.now()}.jpg`, { type: mime })
}

// Straight to marketing/upload-image rather than marketingBackend.uploadImage,
// which would add every thumbnail to the salon's photo library.
export const uploadDataUrl = async (dataUrl) => {
  const form = new FormData()
  form.append('image', dataUrlToFile(dataUrl))
  const res = await axios.post(API.MARKETING_UPLOAD_IMAGE, form, {
    headers: { authorization: 'Basic YmV1YXBwOmJldWFwcA==', accessToken: `${localStorage.getItem('accessToken')}` },
  }).then(unwrap)
  if (!res || !/^https:\/\//.test(res.url || '')) throw new Error('No image address came back')
  return res.url
}
